// extracted by mini-css-extract-plugin
export var buttonWrapper = "mini-faq-dr-module--button-wrapper--ced39";
export var header = "mini-faq-dr-module--header--5f698";
export var homeMiniFaq = "mini-faq-dr-module--home-mini-faq--e2d98";
export var questions = "mini-faq-dr-module--questions--bec9d";